module.exports = __webpack_public_path__ + "img/1.6052b222.png";